export const PERMISSIONS = {
  // Dashboard
  DASHBOARD: 'DASHBOARD',
  // Project
  PROJECT_VIEW: 'PROJECT_VIEW',
  PROJECT_CREATE: 'PROJECT_CREATE',
  PROJECT_UPDATE: 'PROJECT_UPDATE',
  PROJECT_DELETE: 'PROJECT_DELETE',

  // Zone (Kho)
  ZONE_VIEW: 'ZONE_VIEW',
  ZONE_CREATE: 'ZONE_CREATE',
  ZONE_UPDATE: 'ZONE_UPDATE',
  ZONE_DELETE: 'ZONE_DELETE',

  // Customer
  CUSTOMER_VIEW: 'CUSTOMER_VIEW',
  CUSTOMER_CREATE: 'CUSTOMER_CREATE',
  CUSTOMER_UPDATE: 'CUSTOMER_UPDATE',
  CUSTOMER_DELETE: 'CUSTOMER_DELETE',

  // Partner
  PARTNER: 'PARTNER',

  // Contract
  CONTRACT_VIEW: 'CONTRACT_VIEW',
  CONTRACT_CREATE: 'CONTRACT_CREATE',
  CONTRACT_UPDATE: 'CONTRACT_UPDATE',
  CONTRACT_DELETE: 'CONTRACT_DELETE',

  // Document
  DOCUMENT_VIEW: 'DOCUMENT_VIEW',
  DOCUMENT_UPLOAD: 'DOCUMENT_UPLOAD',
  DOCUMENT_UPDATE: 'DOCUMENT_UPDATE',
  DOCUMENT_DELETE: 'DOCUMENT_DELETE',
  DOCUMENT_DOWNLOAD: 'DOCUMENT_DOWNLOAD',

  // Electric & Water
  ELECTRIC_WATER_VIEW: 'ELECTRIC&WATER_VIEW',
  ELECTRIC_WATER_CREATE: 'ELECTRIC&WATER_CREATE',
  ELECTRIC_WATER_UPDATE: 'ELECTRIC&WATER_UPDATE',
  ELECTRIC_WATER_DELETE: 'ELECTRIC&WATER_DELETE',

  // Approvals (Maker-Checker)
  MY_REQUEST: 'MY_REQUEST',
  APPROVAL_REQUIRED: 'APPROVAL_REQUIRED',

  // Financial
  REVENUE: 'REVENUE',
  MONEY: 'MONEY',
  MONEY_CHECK: 'MONEY_CHECK',

  // Admin
  ACCOUNT_MANAGEMENT: 'ACCOUNT_MANAGEMENT',
  SETTINGS: 'SETTINGS',
};
